/* eslint-disable */
/*
  core-js override for Chrome 38 based older TV's for Symbol.toPrimitive returning the wrong value for a Symbol parameter
  overrides core-js's es/symbol/to-primitive.js
*/

// Run this before any other code
(function () {
  try {
    var fn = function () { };
    Object.defineProperty(fn, 'name', { value: 'test' });
  } catch (e) {
    // Patch Object.defineProperty for functions
    var originalDefineProperty = Object.defineProperty;
    Object.defineProperty = function (obj, prop, descriptor) {
      if (typeof obj === 'function' && prop === 'name') {
        return obj; // Skip redefining function name
      }
      return originalDefineProperty(obj, prop, descriptor);
    };
  }
})();
